import "./App.css";
import AboutSection from "./components/AboutSection";
import FeaturesSection from "./components/FeatureSection";
import FooterSection from "./components/FooterSection";
import HeroSection from "./components/HeroSection";
import HomePage from "./components/Homepage";
import MapSection from "./components/MapSection";
import Navbar from "./components/Navbar";
import PartnersSection from "./components/PartnersSection";
import ProductCategoriesSection from "./components/ProductCategoriesSection";
import ProductFirstSection from "./components/ProductFirstSection";
import SpecialProductsSection from "./components/SpecialProductsSection";

function App() {
  return (
    <div className="App">
      <HomePage />
      {/* <ProductFirstSection /> */}
    </div>
  );
}

export default App;
